import React from "react";
import { AppReleasesPage } from "./AppReleasesPage";

const AppReleases = () => {
	return <AppReleasesPage />;
};

export default AppReleases;
